import { mapGetters } from 'vuex'
import users from './livechat-users'
import chatbox from './livechat-chatbox'
import api from '@/api'
import LivechatChattool from './livechat-chattool'
import Multiselect from 'vue-multiselect'

import LivechatPagelist from './livechat-pagelist'
import LivechatSearch from './LivechatSearch'
import LivechatSearchBox from './LivechatSearchBox'
import LivechatTab from './LivechatTab'
import { cloneDeep, isEmpty } from 'lodash'
import dayjs from 'dayjs'

export default {
  components: {
    chatbox: chatbox,
    users: users,
    Multiselect,
    LivechatChattool,
    LivechatPagelist,
    LivechatSearch,
    LivechatSearchBox,
    LivechatTab
  },
  data() {
    return {
      app: '',
      timer: '',
      type: 'bot',
      allrentcustomer: [],
      allrentsupplier: [],
      usersearching: false,
      toolListHeight: 0,
      showSearch: false,
      openStartDate: false,
      openStartTime: false,
      openEndDate: false,
      openEndTime: false,
      input: {
        uuAreaName: '',
        search: '',
        uu_register_status: '',
        lastconversationfromdate: null,
        lastconversationtodate: null,
        lastconversationfromtime: null,
        lastconversationtotime: null,
        lastconversationfrom: null,
        lastconversationto: null,
        phoneno: null,
        uu_name: null,
        keyword: '',
        tags: [],
        status: null,
        app: '',
        session: '',
        assignadminname: ''
      },
      loading: false,
      newchatnotify: {},
      timestamp: dayjs().format('x'),
      pageidSelect:''
    }
  },
  created: function() {
    var vm = this

    if (vm.$route.query.user) {
      this.$store.commit('SET_LIVECHAT_TYPE', vm.$route.query.user == 'bot' ? 'bot' : 'admin')
    }
    if (vm.$route.query.userid) {
      var userid = vm.$route.query.userid

      if (userid && this.isUnlock) {
        vm.getUsersdata(userid).then(function(user) {
          if (user) {
            vm.selectedUser = {
              app: user.app,
              first_name: user.first_name,
              last_name: user.last_name,
              lastreply_time: null,
              profile_pic: user.profile_pic,
              session: '',
              sessionvalue: user.sessionvalue,
              userid: user.id,
              uu_areaname: null,
              type: user.context == 'contactadmin' ? 'admin' : ''
            }
          } else {
            vm.$swal({
              type: 'info',
              title: 'Not found this user'
            })
          }
        })
      }
    }

    // if (this.selectedBot.theme == 'ticket') {
    //   this.$store.dispatch('loadAgents')
    //   this.$store.dispatch('loadAgentGroups')
    //   this.$store.dispatch('loadAgentSubGroups')
    // }
    // this.createUnreadInterval()
  },
  beforeDestroy: function() {
    clearInterval(this.timer)
  },
  mounted: function() {
    const vm = this
    if (vm.isUnlock) {
      vm.$store.dispatch('loadIntent')
    }

    if (
      ['universalutilities', 'hafele', 'scgallrent', 'scgworkplace', 'nvbb'].includes(
        vm.selectedBot.theme
      ) ||
      vm.$route.query.app == 'line'
    ) {
      vm.$store.commit('SET_LIVECHAT_APP', 'line')
    } else {
      vm.$store.commit('SET_LIVECHAT_APP', 'facebook')
    }

    vm.$store.commit('SET_LIVECHAT_APP', vm.selectedBot.packages[0])
    
    if (this.selectedBot.connect_zrm_business_profile_id) {
      this.$store.dispatch('updateZrmDetail') 
    }
  },
  computed: {
    // isUnlock() {
    //   var bot = this.botlist.find(el => {
    //     return el.pageid == this.$store.state.livechat.pageid
    //   })
    //   if (!bot) return false
    //   return (
    //     (bot.pagetype == 'enterprise' && this.$store.state.livechatPageList.includes(bot.theme)) ||
    //     this.$store.state.livechatPageIdList.includes(bot.pageid) ||
    //     (bot.theme == 'ecommercebasic' && bot.pageid == '270028443161479') ||
    //     bot.isUnlockLivechat
    //   )
    // },

    ...mapGetters({
      isUnlock: 'getUnlockLivechat',
      selectedBot: 'selectedBot',
      botlist: 'botlist',
      searchlist: 'getLivechatSearching',
      astonAdmins: 'getAstonAdmins',
      loadingAstonAdmin: 'getLoadingAstonAdmins',
      livechat_bot: 'selectedLivechatBot'
    }),
    channelOptions() {
      const vm = this
      let packages = this.selectedBot.packages
      
      let channels = []
      if (
        vm.livechat_bot &&
        !['universalutilities', 'hafele', 'scgallrent', 'nvbb', 'scgworkplace'].includes(
          vm.livechat_bot.theme
        )
      ) {
        channels.push('facebook')
      }
      channels.push('line')
      if (packages.includes('google')) {
        channels.push('google')
      }
      if (packages.includes('whatsapp')) {
        channels.push('whatsapp')
      }
      if (
        vm.livechat_bot &&
        !['universalutilities', 'hafele', 'scgallrent', 'nvbb'].includes(vm.livechat_bot.theme)
      ) {
        channels.push('instagram')
      }
      channels = channels.filter(el => packages.includes(el))
      return channels
    },
    computedAstonAdmins() {
      if (this.$aston.astonpages.includes(this.$store.state.livechat.pageid)) {
        if (this.astonAdmins) {
          var admins = this.astonAdmins.map(el => {
            return {
              text: el.name,
              value: el.name
            }
          })
          admins.unshift({ text: 'ยังไม่ได้ Assign', value: '' })
          return admins
        } else {
          return []
        }
      } else {
        return []
      }
    },

    selectedUser: {
      get() {
        return this.$store.state.livechat.currentUser
      },
      set(newVal) {
        this.$store.state.livechat.currentUser = newVal
      }
    },
    filter() {
      return this.$store.state.filter
    },
    areaname: function() {
      var area = this.$store.state.uuAreaName
      area.unshift('')
      return area
    }
  },
  methods: {
    async clearSearchUserid() {
      this.$router
        .push({
          name: 'allinonechat',
          path: '/allinonechat'
        })
        .catch(() => {})
      this.$store.dispatch('loading')
      if (this.$aston.astonpages.includes(this.$store.state.livechat.pageid)) {
        this.$set(this.$store.state.livechat, 'pageid', '1493632560856869')
      }
      const channel = this.channelOptions[0] || 'facebook'
      this.$store.commit('SET_LIVECHAT_APP', channel)
      this.$set(this.$store.state.livechat, 'userid', null)
      await this.$store.dispatch('loadLatestUsers', {
        type: this.type
      })
      this.$store.dispatch('loading')
    },
    createUnreadInterval() {
      let vm = this
      // if (this.timer) clearInterval(this.timer)

      if (this.isUnlock) {
        try {
          vm.livechatnotiunread().then(val => {
            if (
              val &&
              document.getElementById('noti_sound') &&
              !JSON.parse(localStorage.getItem('muteChat'))
            ) {
              document.getElementById('noti_sound').volume = 1
              document.getElementById('noti_sound').play()
            }
          })
        } catch (error) {
          console.error(error)
        }

        // vm.timer = setInterval(() => {
        // try {
        //   vm.livechatnotiunread().then(val => {
        //     if (
        //       val &&
        //       document.getElementById('noti_sound') &&
        //       !JSON.parse(localStorage.getItem('muteChat'))
        //     ) {
        //       document.getElementById('noti_sound').volume = 1
        //       document.getElementById('noti_sound').play()
        //     }
        //   })
        // } catch (error) {
        //   console.error(error)
        // }
        // }, vm.$store.state.livechat.maxFatchUserTime)
      }
    },
    onSearch(payload) {
      this.usersearching = payload
    },
    async changePage(pageid) {
      if (pageid) {
        this.pageidSelect = pageid
      }
      this.usersearching = true
      this.newchatnotify = {}
      this.$store.commit('CLEAR_LIVECHAT_USERS')
      this.selectedUser = null
      try {
        await this.$store.dispatch('loadLivechatUsers')
        this.usersearching = false
      } catch (error) {
        this.usersearching = false
      }
    },
    deleteTag(index) {
      this.$store.state.livechat.filter.tags.splice(index, 1)
    },
    clearSearch() {},
    async clearAllUnread() {
      this.livechatnotiunread()
      this.$store.dispatch('loadLatestUsers', {
        type: this.type
      })
    },
    livechatnotiunread() {
      const vm = this
      return new Promise((resolve, reject) => {
        if (!vm.isUnlock) {
          reject()
        }
        api.livechatnotiunread({
          pageid: vm.$store.state.livechat.pageid,
          line_modular_botid: this.$store.state.livechat.line_modular_botid,
        }, (err, response) => {
          let old_chatnotify = cloneDeep(vm.newchatnotify)
          vm.newchatnotify = response.data && response.data.length > 0 ? response.data[0] : {}
          vm.$store.state.livechat.users_unread = Object.assign(
            vm.$store.state.livechat.users_unread,
            response.data && response.data.length > 0 && response.data[0].user_obj
              ? response.data[0].user_obj
              : {}
          )
          let found = false
          if (
            old_chatnotify &&
            !isEmpty(old_chatnotify) &&
            vm.newchatnotify &&
            !isEmpty(vm.newchatnotify)
          ) {
            let new_chatnotify = vm.newchatnotify
            for (const property in old_chatnotify) {
              old_chatnotify[property] = old_chatnotify[property]
                ? parseInt(old_chatnotify[property])
                : 0
            }
            for (const property in new_chatnotify) {
              new_chatnotify[property] = new_chatnotify[property]
                ? parseInt(new_chatnotify[property])
                : 0
            }

            for (const property in new_chatnotify) {
              if (old_chatnotify[property] < new_chatnotify[property]) {
                found = true
                break
              }
            }
          }

          resolve(found)
        })
      })
    },
    getUsersdata: function(userid) {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = {
          userid: userid,
          pageid: vm.$store.state.livechat.pageid
        }

        // api.getUsersdata(data, function(error, response) {
        //   if (error) {
        //     reject(error)
        //   }

        //   if (response.data) {
        //     resolve(response.data[0])
        //   } else {
        //     resolve(undefined)
        //   }
        // })
      })
    },
    onEndSession: async function() {
      try {
        const vm = this
        await vm.endSession()
  
        vm.$set(vm.$store.state.livechat, 'currentUser', null)
        vm.$store.dispatch('updateLivechatUser', null)
        vm.$store.dispatch('forceLoadLastestUsers')

        if (vm.afterEndSession) {
          vm.afterEndSession()
        }
      } catch (err) {
        console.log('err: ', err);
        this.$swal.fire({
          title: this.$t('Unsuccessful'),
          text: err.message,
          type: 'error',
          confirmButtonText: this.$t('Confirm'),
          reverseButtons: true,
          footer: this.$t('if_you_want_any_help_text')
        })
      }
    },
    endSession: async function() {
      let vm = this
      if (vm.selectedUser == null || vm.selectedBot == null) {
        return false
      }
      if (vm.selectedUser.group_id) {
        var dataGroup = {
          group_id: vm.selectedUser.group_id,
          value: {
            context: ''
          }
        }
        vm.$store.dispatch('loading')
        var res = await api.editGroupInfo(dataGroup)
        if (res) {
          vm.$set(vm.selectedUser, 'type', '')
          vm.$store.commit('SET_LIVECHAT_USER', vm.selectedUser)

          vm.$store.dispatch('loading')
        }
      } else {
        let data = {
          pageid: vm.$store.state.livechat.pageid,
          userid: vm.selectedUser.userid,
          user: vm.selectedUser
        }
        return new Promise((resolve, reject) => {
          vm.$store.dispatch('loading')
          api.endSessionChat(data, function(error, response) {
            if (error) {
              vm.$store.dispatch('loading')
              reject(error)
            }
            vm.$set(vm.selectedUser, 'type', '')
            vm.$set(vm.selectedUser, 'context', '')
            vm.$store.commit('SET_LIVECHAT_USER', null)
            vm.$store.commit('SET_LIVECHAT_USER', vm.selectedUser)

            vm.$store.dispatch('loading')
            resolve()
          })
        })
      }
    },
    onOpenSession: async function() {
      try {
        const vm = this
        await vm.openSession()
        vm.$store.commit('SET_LIVECHAT_TYPE', 'admin')
        const user = vm.$store.state.livechat.currentUser
        if (user) {
          user.type = vm.type
          vm.$store.dispatch('updateLivechatUser', user)
        }
        vm.$store.dispatch('forceLoadLastestUsers')
        // this.updateRoute()
        this.afterOpenSession()
      } catch (err) {
        this.$swal.fire({
          title: this.$t('Unsuccessful'),
          text: err.message,
          type: 'error',
          confirmButtonText: this.$t('Confirm'),
          reverseButtons: true,
          footer: this.$t('if_you_want_any_help_text')
        })
      }
    },
    afterOpenSession() {},
    openSession: async function() {
      let vm = this

      if (vm.selectedUser == null || vm.selectedBot == null) {
        return false
      }
      let data = {
        pageid: vm.$store.state.livechat.pageid,
        userid: vm.selectedUser.userid,
        user: vm.selectedUser
      }

      if (vm.selectedUser.group_id) {
        var dataGroup = {
          group_id: vm.selectedUser.group_id,
          value: {
            context: 'contactadmin'
          }
        }
        vm.$store.dispatch('loading')
        var res = await api.editGroupInfo(dataGroup)
        if (res) {
          vm.$set(vm.selectedUser, 'type', 'admin')
          vm.$set(vm.selectedUser, 'context', 'contactadmin')
          vm.$store.commit('SET_LIVECHAT_USER', null)
          vm.$store.commit('SET_LIVECHAT_USER', vm.selectedUser)

          vm.$store.dispatch('loading')
        }
      } else {
        return new Promise((resolve, reject) => {
          vm.$store.dispatch('loading')
          api.openSessionChat(data, function(error, response) {
            if (error) {
              vm.$store.dispatch('loading')

              reject(error)
            }
            vm.$set(vm.selectedUser, 'type', 'admin')
            vm.$set(vm.selectedUser, 'context', 'contactadmin')
            vm.$store.commit('SET_LIVECHAT_USER', null)
            vm.$store.commit('SET_LIVECHAT_USER', vm.selectedUser)

            vm.$store.dispatch('loading')
            resolve()
          })
        })
      }
    },
    updateRoute: function() {
      var query = { ...this.$route.query }
      query.app = this.app
      query.user = this.type

      this.$router
        .push({
          name: 'allinonechat',
          path: '/allinonechat',
          query: query
        })
        .catch(() => {})
      this.routeValue = JSON.stringify(this.$route.query)
    },
    sendMessage: function(payload) {
      let vm = this
      let data = {
        pageid: vm.$store.state.livechat.pageid,
        userid: payload.data.user.userid,
        adminid: this.$store.state.userid,
        app: payload.data.app,
        messagetype: payload.data.type,
        messagevalue: payload.data.text,
        page_access_token: vm.selectedBot.page_access_token
      }

      api.sendMessage(data, function(error, response) {
        if (error) {
          console.error(error)
          // vm.$store.dispatch('loading')
          return
        }
        // vm.$store.dispatch('loading')
      })
    },
    onClickUser() {
      const chatbox = this.$refs.chatbox
      if(chatbox) {
        chatbox.setRead()
      }
    }
  },
  watch: {
    selectedBot: function(newVal, oldVal) {
      const vm = this
      if (newVal != oldVal) {
        vm.$set(vm.$store.state.livechat, 'currentUser', null)
      }
    },
    livechat_bot: function(newVal, oldVal) {
      const vm = this
      if (newVal != oldVal) {
        vm.$set(vm.$store.state.livechat, 'currentUser', null)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/view/livechat/Livechat.js